export interface SidebarBrandPresentation {
  mark: 'mpr-crosshair'
  title: string
  subtitle: string
}

export function getSidebarBrandPresentation(): SidebarBrandPresentation {
  return {
    mark: 'mpr-crosshair',
    title: 'RadCore',
    subtitle: 'AI Reading Room',
  }
}
